import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
// * hooks
import { useAuth } from "../services/auth";
// * custom components
import Uploader from "../components/Uploader";
import RewardList from "../components/reward/List";
import {
  useBrandItemsList,
  useRegisterRewardMutation,
} from "../hooks/rewardQueries";

const RewardScreen = () => {
  const { authData } = useAuth();
  const queryClient = useQueryClient();

  const brandListResult = useBrandItemsList("fb507a0b75e0f62f65b798424555733f");
  const [brandList, setBrandList] = useState([]);
  useEffect(() => {
    if (brandListResult.isSuccess) {
      setBrandList(brandListResult.data);
    }
  }, [brandListResult.isSuccess, brandListResult.data]);

  const rewardNameRef = useRef<HTMLInputElement>(null);
  const brandNameRef = useRef<HTMLInputElement>(null);
  const [brandId, setBrandId] = useState<number>();
  const productLinkRef = useRef<HTMLInputElement>(null);
  const discountRef = useRef<HTMLInputElement>(null);
  const couponRef = useRef<HTMLInputElement>(null);
  const pointRef = useRef<HTMLInputElement>(null);
  const [objectKeys, setObjectKeys] = useState<string[]>([]);
  const regexPointInput = useCallback((evt: ChangeEvent<HTMLInputElement>) => {
    const inputValue = evt.target.value;
    const numericValue = inputValue.replace(/[^0-9]/g, "");

    evt.target.value = numericValue;
  }, []);

  const listRefresh = useCallback(() => {
    queryClient.invalidateQueries(["rewardItem", { type: "list" }]);
  }, [queryClient]);
  const { mutate: createRewardMutate, isLoading: isRewardCreating } =
    useRegisterRewardMutation("fb507a0b75e0f62f65b798424555733f", listRefresh);
  const onCreateReward = useCallback(() => {
    if (isRewardCreating || brandId === undefined || objectKeys.length === 0) {
    } else {
      createRewardMutate({
        name: rewardNameRef.current?.value,
        link: productLinkRef.current?.value,
        objectkey: objectKeys[0],
        point: pointRef.current?.value,
        discount: discountRef.current?.value,
        couponCode: couponRef.current?.value,
        brandId,
      });
    }
  }, [createRewardMutate, isRewardCreating, objectKeys, brandId]);

  return (
    <div className="py-[38px] px-[28px] h-full bg-backgroundSecondary">
      <div className="px-[29px] h-[54px] w-full rounded-md shadow-md bg-backgroundTertiary flex flex-col justify-center text-bg01 font-semibold">
        RewardItems management
      </div>
      <div className="mt-[32px] flex flex-row">
        <div className="px-[29px] py-[27px] w-1/4 rounded-md shadow-md bg-backgroundTertiary">
          <div className="text-bg01 font-semibold">
            New Reward Item Registration
          </div>
          <div className="mt-[22px] text-black">Reward Item Name*</div>
          <input
            ref={rewardNameRef}
            placeholder="Enter Reward Item Name"
            className="mt-2 px-[15px] py-[8px] w-full rounded-md border border-primary bg-backgroundPrimary text-sm"
          />
          <div className="mt-[12px] text-black">Upload Image Of Product</div>
          <Uploader
            value={objectKeys}
            setValue={setObjectKeys}
            additionalClass="mt-2"
          />
          <div className="mt-[12px] text-black">Brand Name*</div>
          <div className="mt-2 w-full flex items-center">
            <input
              ref={brandNameRef}
              placeholder="Enter Brand Name"
              className="flex-1 px-[15px] py-[8px] rounded-md border border-primary bg-backgroundPrimary text-sm"
            />
            <div
              onClick={() => {
                const filtered: any[] = brandList.filter(
                  (_: any) =>
                    _.type === "Brand" && _.name === brandNameRef.current?.value
                );

                setBrandId(filtered.length > 0 ? filtered[0].id : undefined);
              }}
              className={`ml-4 w-[60px] h-[30px] rounded bg-${
                brandId ? "backgroundPrimary text-primary" : "bg01 text-black"
              } text-sm flex flex-col items-center justify-center  hover:opacity-80 cursor-pointer`}
            >
              {brandId ? "okay" : "Check"}
            </div>
          </div>
          <div className="mt-[12px] text-black">Product Link*</div>
          <input
            ref={productLinkRef}
            placeholder="Enter Product Link"
            className="mt-2 px-[15px] py-[8px] w-full rounded-md border border-primary bg-backgroundPrimary text-sm"
          />
          <div className="mt-[12px] text-black">Discount Description*</div>
          <input
            ref={discountRef}
            placeholder="Enter Discount Description"
            className="mt-2 px-[15px] py-[8px] w-full rounded-md border border-primary bg-backgroundPrimary text-sm"
          />
          <div className="mt-[12px] text-black">Point</div>
          <input
            ref={pointRef}
            onChange={regexPointInput}
            placeholder="Enter Points ( number )"
            className="mt-2 px-[15px] py-[8px] w-full rounded-md border border-primary bg-backgroundPrimary text-sm"
          />
          <div className="mt-[12px] text-black">Coupon code</div>
          <input
            ref={couponRef}
            placeholder="Enter Coupon code"
            className="mt-2 px-[15px] py-[8px] w-full rounded-md border border-primary bg-backgroundPrimary text-sm"
          />
          <div className="mt-[20px] flex flex-row">
            <div
              onClick={onCreateReward}
              className="w-[120px] h-[44px] rounded bg-bg01 text-backgroundTertiary flex flex-col justify-center items-center cursor-pointer hover:opacity-80"
            >
              Add
            </div>
            <div className="ml-4 w-[120px] h-[44px] rounded bg-backgroundPrimary text-primary flex flex-col justify-center items-center cursor-pointer hover:opacity-80">
              Cancel
            </div>
            di
          </div>
        </div>
        <div className="ml-6 px-[29px] py-[27px] w-3/4 rounded-md shadow-md bg-backgroundTertiary">
          <div className="text-bg01 font-semibold">Reward Item lists</div>
          <div className="mt-[22px]">
            <RewardList />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardScreen;
